import { EmailTemplateDetail } from '@dealstack/frontend/shared/components/EmailTemplates/components/EmailTemplateDetail';
import { EmailTemplateScopeKind } from '@dealstack/frontend/shared/components/EmailTemplates/EmailTemplates.types';
import {
	MIP_MANAGE_ROUTES,
	PROGRAMME_SETTINGS_ROUTES,
} from '@dealstack/frontend/app/pages/Routing/routes';
import { mipManagePath } from '@dealstack/frontend/app/pages/Routing/routes.utils';
import { PageAbsoluteContainer } from '@dealstack/frontend/shared/layout/PageAbsoluteContainer/PageAbsoluteContainer';
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

interface Props {
	mipId: string;
}

export const ProgrammeEmailTemplateDetailPage = ({ mipId }: Props) => {
	const navigate = useNavigate();
	const { templateType = '', dealId = '' } = useParams<{
		templateType: string;
		dealId: string;
	}>();
	const scope = useMemo(() => ({ kind: EmailTemplateScopeKind.PROGRAMME, id: mipId }), [mipId]);

	const goBackToList = () =>
		navigate(
			mipManagePath(
				`${MIP_MANAGE_ROUTES.SETTINGS}${PROGRAMME_SETTINGS_ROUTES.EMAIL_TEMPLATES}`,
				{ dealId, mipId }
			)
		);

	return (
		<PageAbsoluteContainer>
			<EmailTemplateDetail scope={scope} templateType={templateType} onBack={goBackToList} />
		</PageAbsoluteContainer>
	);
};
